export enum QuestionType {
    MultipleChoice = 1,
    LongMultipleChoice,
    DragAndDrop,
    Link,
    ClickMap,
}
